import { AiseaApiFactory } from "@/api/aisea/apiFactory";
const enterpriseLaborTemplateApi = AiseaApiFactory.get("enterpriseLaborTemplate");

export default {
  async fetchTemplateList ({ commit }, payload) {
    let res = await enterpriseLaborTemplateApi.search(payload);
    commit("SET_TEMPLATES", res.data.templates);
  },

  async fetchTemplate ({ commit }, id) {
    let res = await enterpriseLaborTemplateApi.fetch(id);
    commit("SET_TEMPLATE", res.data);
  },

  async addTemplate (_, payload) {
    const res = await enterpriseLaborTemplateApi.add(payload);
    return res;
  },

  async updateTemplate (_, payload) {
    const res = await enterpriseLaborTemplateApi.update(payload.id, payload.params);
    return res;
  },

  async deleteTemplate (_, id) {
    const res = await enterpriseLaborTemplateApi.delete(id);
    return res;
  },

  async selectTemplate (_, id) {
    const res = await enterpriseLaborTemplateApi.select(id);
    return res;
  },

};